import React from 'react';
import { Loader } from 'lucide-react';
import './PageLoader.css';

const PageLoader = ({ message = 'Loading...' }) => {
    return (
        <div className="page-loader-container">
            <div className="page-loader-wrapper">
                <div className="page-loader-spinner">
                    <div className="page-loader-ring"></div>
                    <div className="page-loader-ring page-loader-ring-second"></div>
                    <div className="page-loader-ring page-loader-ring-third"></div>
                    <Loader className="page-loader-icon" size={32} />
                </div>
                <p className="page-loader-message">{message}</p>
            </div>
        </div>
    );
};

export default PageLoader;